import React, { useContext } from 'react';
import { View } from 'react-native';
import PropTypes from 'prop-types';
import { Avatar } from '../common/Avatar';
import { H3, H5, Paragraph } from '../text';
import LayoutContext from '../../contexts/Layout';

const AvatarPlusText = ({ avatarName, avatar, description, id, nodeTypeAlias, titleSubText }) => {
    const { layout } = useContext(LayoutContext);

    return (
        <View
            key={id}
            style={{ marginBottom: layout.styleGuide.componentSeparator, marginHorizontal: layout.styleGuide.spacer1 }}
            dataSet={{
                umbracoComponent: nodeTypeAlias,
                spacerBottom: `StyleGuide.ComponentSeparator(${layout.styleGuide.componentSeparator})`,
                spacerLeft: `StyleGuide.Spacer1(${layout.styleGuide.spacer1})`,
                spacerRight: `StyleGuide.Spacer1(${layout.styleGuide.spacer1})`
            }}
        >
            <View style={{ flexDirection: 'row', marginVertical: layout.styleGuide.spacer2 }} dataSet={{ spacerBottom: `StyleGuide.Spacer2(${layout.styleGuide.spacer2})` }}>
                <Avatar
                    imageUri={avatar.cdnImagePath}
                    size={96}
                    style={{ marginHorizontal: 0, marginRight: layout.styleGuide.spacer7 }}
                    dataSet={{ spacerRight: `StyleGuide.Spacer7(${layout.styleGuide.spacer7})` }}
                />
                <View style={{ alignItems: 'flex-start', justifyContent: 'center' }}>
                    <H3 text={avatarName} />
                    {!!titleSubText && <H5 style={{ color: '#8897a2' }} text={titleSubText} />}
                </View>
            </View>
            <View
                style={{ flexDirection: 'row', justifyContent: 'center', marginBottom: layout.styleGuide.spacer2 }}
                dataSet={{ spacerBottom: `StyleGuide.Spacer2(${layout.styleGuide.spacer2})` }}
            >
                <Paragraph text={description} />
            </View>
        </View>
    );
};

AvatarPlusText.propTypes = {
    avatarName: PropTypes.string,
    cdnImagePath: PropTypes.string,
    description: PropTypes.string,
    titleSubText: PropTypes.string
};

export default AvatarPlusText;
